import Store from 'store';

export const CHANGE_VOLUME = 'CHANGE_VOLUME';
const change = (volume) => ({
    type: CHANGE_VOLUME,
    volume,
});

export const MUTE_VOLUME = 'MUTE_VOLUME';
const mute = (oldVolume, volume) => ({
    type: MUTE_VOLUME,
    oldVolume,
    volume,
});

export const changeVolume = (volume) => (dispatch) => {
    Store.set('volume', volume); // local store

    return dispatch(change(volume));
};

export const toggleMuteVolume = () => (dispatch, getState) => {
    const volume = getState().aovivoBar.Volume;
    const value = volume.volume;

    return dispatch(mute(value, value > 0 ? 0 : volume.oldVolume));
};
